/**
 * Created by akrio on 2018/3/23.
 */
import {
  CURRENT_USER_INFO,
  CURRENT_USER_INFO_SIMPLE,
  CURRENT_PUBLISHER_ID,
  CURRENT_PUBLISHER_SIMPLE,
  CURRENT_PUBLISHER_CAPTION_COMMENT_SIMPLE,
  PUBLISHER_CAPTION_COMMENT_LIST,
} from "../mutation-types";
import { User } from "../../service/model/user";

export default {
  state: {
    currentPublisherId: null,
    commentCaptionList: {},
    userInfo: null, // 当前登录人信息
  },
  mutations: {
    [CURRENT_USER_INFO](state, userInfo) {
      state.userInfo = userInfo;
    },
    [CURRENT_PUBLISHER_ID](state, publisherId) {
      state.currentPublisherId = publisherId;
    },
    [PUBLISHER_CAPTION_COMMENT_LIST](state, commentCaptionList) {
      state.commentCaptionList = commentCaptionList;
    },
  },
  getters: {
    [CURRENT_USER_INFO](state) {
      // 获取当前登录人信息
      return state.userInfo;
    },
    [CURRENT_USER_INFO_SIMPLE](state) {
      // 获取当前登录人信息
      return new User(state.userInfo);
    },
    [CURRENT_PUBLISHER_ID](state) {
      return state.currentPublisherId;
    },
    [CURRENT_PUBLISHER_SIMPLE](state) {
      if (!state.userInfo) {
        return null;
      }
      // 获取当前登录人信息
      const user = new User(state.userInfo);
      // 查找选中项
      let publisher = user.linkedInstagramList.find(
        (l) => l.publisherId === state.currentPublisherId
      );
      // 如果找不到选中项则默认取第一个 如果一个publisher都没有返回undefined
      if (publisher === undefined && user.linkedInstagramList.length > 0) {
        // 查找第一个不是linkin的账号
        const linkedList = user.linkedInstagramList.filter(
          (l) => l.socialNetwork <= 4 && l.socialNetwork !== 1
        );
        if (linkedList.length > 0) {
          publisher = linkedList[0];
        } else {
          console.error("当前登录人账号全是linkin账号 不能帮他选中");
          return null;
        }
      } else if (publisher === undefined) {
        console.error("无法找到匹配的publisher");
        return null;
      }
      return publisher;
    },
    [PUBLISHER_CAPTION_COMMENT_LIST](state) {
      return state.commentCaptionList;
    },
    [CURRENT_PUBLISHER_CAPTION_COMMENT_SIMPLE](state) {
      if (!Array.isArray(state.commentCaptionList)) {
        return {
          publisherId: state.currentPublisherId,
          caption: [],
          comment: [],
        };
      }
      const result = state.commentCaptionList.find(
        (item) => item.publisherId === state.currentPublisherId
      );
      return result;
    },
  },
};
